// extracted by mini-css-extract-plugin
export default {"highlight":"Highlight_highlight__o5XFD","positive":"Highlight_positive__U1hbV","negative":"Highlight_negative__5Bq2l"};